var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRubin = function SvgRubin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 154 154"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#rubin_svg__filter0_d_3147_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEB62",
    strokeWidth: 6,
    d: "M139 77c0 34.242-27.758 62-62 62-34.241 0-62-27.758-62-62S42.76 15 77 15s62 27.758 62 62Z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#rubin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9FA5",
    strokeWidth: 6,
    d: "M138.918 76.281c0 34.242-27.758 62-62 62s-62-27.758-62-62c0-34.241 27.758-62 62-62s62 27.759 62 62Z",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F4F",
    stroke: "#D02F69",
    strokeWidth: 1.196,
    d: "M110.408 51.962 81.186 34.295a1.8 1.8 0 0 0-1.574-.138L47.766 46.481a1.79 1.79 0 0 0-1.14 1.516l-4.33 49.51a1.79 1.79 0 0 0 .815 1.664l29.126 18.76c.497.32 1.12.374 1.665.145l31.941-13.416a1.79 1.79 0 0 0 1.092-1.497l4.332-49.51a1.79 1.79 0 0 0-.859-1.691Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F21B5C",
    d: "m42.259 98.031 11.385-4.254 3.442-39.344-9.862-7.578z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB0333",
    d: "m72.9 118.502 1.22-13.937-20.364-13.538-11.504 7.081z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A76",
    d: "m106.774 103.796-9.873-9.05-22.858 9.812-1.213 13.867z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A6B",
    d: "m56.765 56.638 22.554-8.76 1.205-13.777-33.19 12.823z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBB6CF",
    d: "m79.222 47.816 1.196-13.668 30.498 18.463-11.365 7.66z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.702,
    cy: 46.65,
    fill: "#FF9BB3",
    rx: 1.666,
    ry: 1.542,
    transform: "rotate(5 67.702 46.65)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.812,
    cy: 42.503,
    fill: "#FF9BB3",
    rx: 3.297,
    ry: 3.051,
    transform: "rotate(5 73.812 42.503)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m53.703 90.241-11.567 7.785 12.817-6.002zM99.945 61.366l11.018-8.72-12.532 6.467zM95.347 95.728l11.451 8.107-9.63-9.342zM57.99 55.91l-10.767-9.056L56.43 57.67zM73.337 103.717l-.343 12.682 2.472-11.727zM80.478 48.335l-.231-12.357-2.5 12.118z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE2B45",
    stroke: "#fff",
    strokeWidth: 1.196,
    d: "M98.902 59.808 80.058 48.37a1.8 1.8 0 0 0-1.58-.139l-20.545 7.993a1.79 1.79 0 0 0-1.136 1.514l-2.828 32.33a1.79 1.79 0 0 0 .812 1.661l18.782 12.147a1.8 1.8 0 0 0 1.671.146l20.607-8.7a1.79 1.79 0 0 0 1.088-1.496l2.829-32.33a1.79 1.79 0 0 0-.856-1.688Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC4D2",
    stroke: "#FFC4E0",
    strokeWidth: 0.368,
    d: "M83.343 86.316q2.523.275 3.806.387.781.068 2.09.145a.735.735 0 0 0 .776-.67l.169-1.926a.714.714 0 0 0-.65-.78 55 55 0 0 0-.776-.055 49 49 0 0 1-2.908-.26 34 34 0 0 0-2.442-.215l-.275-.016c-.256-.015-.397-.3-.234-.528l8.968-12.535a.74.74 0 0 0 .135-.365l.12-1.386a.74.74 0 0 0-.682-.799q-11.346-.814-11.512-.829l-.322-.028a.737.737 0 0 0-.798.67l-.127 1.452a.71.71 0 0 0 .629.776c.344.035.706.056 1.077.078l.236.014c.455.027.924.06 1.403.124.605.08 1.096.114 1.61.148l.067.004c.495.033 1.018.067 1.698.143.698.079 1.114.108 1.434.127.267.016.397.306.222.521-.34.418-.791.963-1.443 1.75-.373.45-.811.978-1.33 1.607-1.032 1.247-2.087 2.316-3.07 3.31l-.025.026c-.97.983-1.875 1.897-2.603 2.834-1.439 1.863-2.055 3.305-2.164 3.834l-.002.01-.001.011-.087.992a.75.75 0 0 0 .693.81c.622.047 1.384.122 1.966.18.291.028.538.052.698.066q1.159.102 3.654.373Zm-9.23-2.868a.7.7 0 0 0-.587-.66 22 22 0 0 0-1.332-.14 57.445 57.445 0 0 1-4.938-.614.37.37 0 0 1-.308-.395l.01-.115c.032-.426.068-.895.175-1.966a72 72 0 0 0 .27-3.03.375.375 0 0 1 .39-.341c.803.027 2.228.047 5.077.063a.738.738 0 0 0 .736-.828l-.147-1.173a.74.74 0 0 0-.609-.637l-.108-.018c-.549-.094-1.396-.24-2.642-.439a56 56 0 0 1-2.054-.374.346.346 0 0 1-.284-.374l.03-.213c.04-.28.083-.57.102-1.338.028-.672.069-1.05.103-1.317.028-.212.229-.386.466-.395l.179-.009c.33-.017.87-.044 2.319-.026q3.193.042 4.68-.014a.72.72 0 0 0 .679-.844l-.185-1.1a.72.72 0 0 0-.568-.59q-1.468-.279-5.215-.654-3.386-.34-4.688-.512a.743.743 0 0 0-.833.594q-.516 2.791-1.113 9.01-.606 6.302-1.115 9.24c-.062.359.145.728.524.81q.855.182 2.474.323 1.343.117 4.316.27 2.294.14 3.494.23a.742.742 0 0 0 .797-.78z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "rubin_svg__a",
    width: 152.034,
    height: 152.034,
    x: 0.901,
    y: 0.264,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.84 0 0 0 0 0.876857 0 0 0 0 0.9 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3147_10961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3147_10961",
    result: "shape"
  })))));
};
export default SvgRubin;